module.exports = __webpack_public_path__ + "img/jd.232af7bc.png";